<mat-form-field class="dict-additional-fields">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)"
              [placeholder]="label">
    <mat-option>
      <ngx-mat-select-search [formControl]="searchFilterCtrl"
                             placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono">
      </ngx-mat-select-search>
    </mat-option>

    <mat-option *ngFor="let field of items"
                [value]="field.uuid">
      <div class="additional-field-option">
        <span class="field-name">{{field.productName}}</span>
        <span *ngIf="showFieldInfo" class="field-info">
            <span class="field-type">{{field.productName}}</span>
          </span>
      </div>
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    &&control.value.hasOwnProperty('length')
    && control.value.length > 0) || (control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
